import { render, staticRenderFns } from "./setSettle.vue?vue&type=template&id=a695e47c&scoped=true&"
import script from "./setSettle.vue?vue&type=script&lang=js&"
export * from "./setSettle.vue?vue&type=script&lang=js&"
import style0 from "./setSettle.vue?vue&type=style&index=0&id=a695e47c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a695e47c",
  null
  
)

export default component.exports